import React from 'react';
import { css } from '@emotion/react';
import { gray6, gray7 } from 'styles/global_defaults/colors';
import { largeSpacing, quarterSpacing, threeQuartersSpacing } from 'styles/global_defaults/scaffolding';

const DEFAULT_WIDTH = 100;

const SKELETON_WIDTHS: Record<string, number> = {
  total: 120,
  completed: 90,
  in_progress: 100,
  missed_deadline: 130,
  never_active: 110,
};

const skeletonPillStyles = css`
  @keyframes shineAnimation {
    0% {
      background-position: 0% 50%;
    }
    100% {
      background-position: -100% 50%;
    }
  }

  display: inline-flex;
  align-items: center;
  gap: ${quarterSpacing}px;
  padding: ${quarterSpacing}px ${threeQuartersSpacing}px;
  border-radius: 100px;
  background: linear-gradient(90deg, ${gray6} 35%, ${gray7} 45%, ${gray6} 55%);
  background-size: 600% 600%;
  animation: shineAnimation 1.5s infinite;
  height: ${largeSpacing}px;
`;

type SkeletonPillProps = {
  tabId: string;
};

const SkeletonPill = ({ tabId }: SkeletonPillProps) => (
  <div css={skeletonPillStyles} style={{ width: SKELETON_WIDTHS[tabId] ?? DEFAULT_WIDTH }} />
);

export default SkeletonPill;
